import React, { useState } from "react";
import styles from "../Dashboard.module.scss";
import Text from "components/Text";
import Button from "components/Button";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import constants from "../../../../constants";
import moment from "moment";
import { convertTimeMinuteToHour, encodeId } from "utils";
import EditIcon from "../../../../assets/images/edit-icon.svg";
import { addEditEventsConst } from "../../../../accountOwner/pages/AddEvent/addEvents.constants";
import clsx from "clsx"; // If using clsx for better className handling

function RequestApprovalCard({ t, list, handleAction, showLoader = false }) {
  const history = useHistory();
  const leaveStatus = constants.LeaveStatus;
  const timesheetListingStatus = constants.TimesheetListingStatus;
  const [reasonForLeaveState, setReasonForLeaveState] = useState("");

  const startTime = moment(list?.timesheet_StartTime, "h:mm A");
  const endTime = moment(list?.timesheet_EndTime, "h:mm A");
  let duration = moment.duration(moment(endTime).diff(moment(startTime)));

  // Subtract the break duration from the total duration
  const totalDurationWithoutBreak = duration.subtract(
    list?.timesheet_BreakTime,
    "minutes"
  );
  let totalHours = totalDurationWithoutBreak.asHours().toFixed(2);

  const appliedForDate = (startDate, endDate) => {
    let appliedDate = `${moment(startDate).format("MMM D")} - ${moment(
      endDate
    ).format("ll")}`;
    return appliedDate;
  };

  const handlePendingRequestAction = (
    actionType,
    actionTypeId,
    statusId,
    isApproved,
    officeId
  ) => {
    handleAction(
      actionType,
      actionTypeId,
      statusId,
      isApproved,
      officeId,
      reasonForLeaveState
    );
  };

  const handleLeaveStatus = (statusId) => (
    <>
      {/* {statusId === leaveStatus[1].value && <span>{t("pending")}</span>}
      {statusId === leaveStatus[2].value && ( */}
      <span>
        {t(
          `staffTimesheet.${
            leaveStatus.find((res) => res.value === statusId).label
          }`
        )}
      </span>
      {/* )}
      {statusId === leaveStatus[3].value && <span>{t("rejected")}</span>}
      {statusId === leaveStatus[4].value && <span>{t("rejected")}</span>}
      {statusId === leaveStatus[5].value && <span>{t("rejected")}</span>}
      {statusId === leaveStatus[6].value && <span>{t("rejected")}</span>} */}
    </>
  );
  let isShift = list?.eventShiftTag === "Shift" ? true : false;
  const isCancelled = list?.leave_Status === 6;
  const leaveClass = isCancelled ? styles["cancelationleave"] : styles["leave"];
  const leaveTextKey = isCancelled
    ? "staffLeaves.leaveCancellation"
    : "staffTimesheet.leave";
  return (
    <div className={styles.request_approval_body}>
      <div className={styles.name_btn_wrapper}>
        <Text size="14px" weight="600" color="#587E85">
          {list?.timesheetId > 0 && <span> {list?.timesheet_Name}</span>}
          {list?.leave_Id > 0 && <span> {list?.leave_Name}</span>}
          {list?.clockInOutTimeSheetEditRequestId > 0 && (
            <span> {list?.editRequest_Name}</span>
          )}
          {list?.eventShiftId > 0 && <span> {list?.eventShiftAssignedBy}</span>}
        </Text>

        <button
          className={clsx(
            list?.leave_Id && styles.leave_btn_new,
            list?.timesheetId && styles.timesheet_btn_new,
            list?.clockInOutTimeSheetEditRequestId &&
              styles.edit_timesheet_btn_new,
            list?.eventShiftId && styles.shiftevent_btn_new
          )}
        >
          {list?.leave_Id > 0 && (
            <span className={`${styles["approval-status"]} ${leaveClass}`}>
              {t(leaveTextKey)}
            </span>
          )}
          {list?.isHoliday && (
            <span
              className={
                styles["approval-status"] + " me-xxs " + styles["holiday"]
              }
            >
              {" "}
              {t("staff.holiday")}
            </span>
          )}
          {list?.timesheetId > 0 && (
            <span className={styles["approval-status"]}>
              {t("contracts.timesheet")}
            </span>
          )}
          {list?.clockInOutTimeSheetEditRequestId > 0 && (
            <span className={styles["approval-status"]}>
              {t("staffTimesheet.editTimesheet")}
            </span>
          )}
          {list?.eventShiftId > 0 && (
            <span
              className={styles["approval-status"] + " " + styles["shiftevent"]}
            >
              {" "}
              {isShift ? "Shift" : "Event"}
            </span>
          )}
        </button>
      </div>
      <div className={styles.content_column_grid}>
        {/* For Pendig timesheets */}
        {list?.timesheetId > 0 && (
          <>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.date")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.timesheet_Date
                  ? moment(list.timesheet_Date).format("ll")
                  : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.started")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.timesheet_StartTime ? list.timesheet_StartTime : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.finished")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.timesheet_EndTime ? list.timesheet_EndTime : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.break")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.timesheet_BreakTime
                  ? `${convertTimeMinuteToHour(list.timesheet_BreakTime)} Hrs`
                  : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.total")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {totalHours ? `${totalHours} Hrs` : "--"}
              </Text>
            </div>
          </>
        )}
        {list?.eventShiftId > 0 && (
          <>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.date")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.eventShiftDate
                  ? moment(list?.eventShiftDate).format("ll")
                  : "--"}
              </Text>
            </div>
            {[2, 3, 5, 6].includes(list?.repeatedType) && (
              <div>
                <Text size="12px" weight="400" color="#6f7788">
                  end date
                </Text>
                <Text size="14px" weight="600" color="#102c42">
                  {list.eventShiftEndDateRepeatEvent
                    ? moment(list?.eventShiftEndDateRepeatEvent).format("ll")
                    : "--"}
                </Text>
              </div>
            )}
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                Repeat
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {
                  addEditEventsConst
                    .repeatedOptions(t)
                    .find((res) => list?.repeatedType === res.id)?.name
                }
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.started")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list?.eventShiftStartTime
                  ? moment(list?.eventShiftStartTime).format("hh:mm A")
                  : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.finished")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list?.eventShiftEndTime
                  ? moment(list?.eventShiftEndTime).format("hh:mm A")
                  : "--"}
              </Text>
            </div>
          </>
        )}

        {list?.leave_Id > 0 && (
          <>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.appliedFor")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {appliedForDate(list.leave_FromDate, list.leave_ToDate)}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.duration")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list?.leave_Duration ? `${list.leave_Duration} Days` : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.typeOfLeave")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.leave_Type}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.status")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list?.leave_Status
                  ? handleLeaveStatus(list?.leave_Status)
                  : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffLeaves.reasonForLeave")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list?.leave_Description ? list?.leave_Description : "--"}
              </Text>
            </div>
          </>
        )}
        {list?.clockInOutTimeSheetEditRequestId > 0 && (
          <>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.date")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.timesheetRequest_Date
                  ? moment(list.timesheetRequest_Date).format("ll")
                  : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.started")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.timesheet_StartTime ? list.timesheet_StartTime : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" weight="400" color="#6f7788">
                {t("staffTimesheet.finished")}
              </Text>
              <Text size="14px" weight="600" color="#102c42">
                {list.timesheet_EndTime ? list.timesheet_EndTime : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffTimesheet.break")}
              </Text>
              <Text
                size="14px"
                marginBottom="25px"
                weight="600"
                color="#102c42"
              >
                {list.timesheet_BreakTime
                  ? `${convertTimeMinuteToHour(list.timesheet_BreakTime)} Hrs`
                  : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffTimesheet.total")}
              </Text>
              <Text
                size="14px"
                marginBottom="25px"
                weight="600"
                color="#102c42"
              >
                {list.timesheet_EndTime &&
                list.timesheet_StartTime &&
                totalHours
                  ? `${totalHours} Hrs`
                  : "--"}
              </Text>
            </div>
            <div>
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffTimesheet.reasonForEditTimesheet")}
              </Text>
              <Text
                size="14px"
                marginBottom="25px"
                weight="600"
                color="#102c42"
              >
                {list?.reason ? list?.reason : "--"}
              </Text>
            </div>
          </>
        )}
      </div>
      {list?.leave_Id > 0 && (
        <div className="c-field mt-3">
          <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
            {t("taskManagement.addComment")}
          </Text>
          <textarea
            className="c-form-control bg-transparent"
            placeholder={t("taskManagement.addComment")}
            name="location"
            maxLength={500}
            value={reasonForLeaveState}
            onChange={(e) => {
              setReasonForLeaveState(e.target.value);
            }}
          ></textarea>
        </div>
      )}
      <div className={styles.btn_container_edit}>
        <div className={styles.inner_btn_container}>
          <Button
            height="35px"
            padding="11px"
            disabled={showLoader}
            onClick={() => {
              if (list?.timesheetId > 0) {
                handlePendingRequestAction(
                  "Timesheet",
                  list.timesheetId,
                  timesheetListingStatus[2].value
                ); //actionType, actionTypeId, statusId, isApproved
              }
              if (list?.leave_Id > 0) {
                handlePendingRequestAction("Leave", list.leave_Id, null, true); //actionType, actionTypeId, statusId, isApproved
              }
              if (list?.clockInOutTimeSheetEditRequestId > 0) {
                handlePendingRequestAction(
                  "EditTimesheetRequest",
                  list.clockInOutTimeSheetEditRequestId,
                  null,
                  true
                ); //actionType, actionTypeId, statusId, isApproved
              }
              if (list?.eventShiftId > 0) {
                handlePendingRequestAction(
                  "shiftEvent",
                  list?.eventShiftId,
                  null,
                  true,
                  list?.eventShiftOfficeId
                );
              }
            }}
          >
            Accept
          </Button>

          <Button
            borderedSecondary
            height="35px"
            bgColor="#F9FCEE"
            padding="11px"
            disabled={showLoader}
            onClick={() => {
              if (list?.timesheetId > 0) {
                handlePendingRequestAction(
                  "Timesheet",
                  list.timesheetId,
                  timesheetListingStatus[3].value
                );
              }
              if (list?.leave_Id > 0) {
                handlePendingRequestAction("Leave", list.leave_Id, null, false);
              }
              if (list?.clockInOutTimeSheetEditRequestId > 0) {
                handlePendingRequestAction(
                  "EditTimesheetRequest",
                  list.clockInOutTimeSheetEditRequestId,
                  null,
                  false
                );
              }
              if (list?.eventShiftId > 0) {
                handlePendingRequestAction(
                  "shiftEvent",
                  list?.eventShiftId,
                  null,
                  false,
                  list?.eventShiftOfficeId
                );
              }
            }}
          >
            Decline
          </Button>
        </div>
        {list?.leave_Status !== 1 && list?.timesheet_Date && (
          <button
            className={styles.edit_icon}
            onClick={() => {
              list["timesheetDate"] = list?.timesheet_Date;
              history.push({
                pathname: constants.routes.accountOwner.editTimesheetForStaff
                  .replace(":officeId", encodeId(list?.officeId))
                  .replace(":staffId", encodeId(list?.userId)),
                state: {
                  detail: list,
                  staffDetail: {
                    name:
                      list?.timesheetId > 0
                        ? list?.timesheet_Name
                        : list?.editRequest_Name,
                  },
                },
              });
            }}
          >
            <img src={EditIcon} alt="EditIcon" />
          </button>
        )}
      </div>
    </div>
  );
}

export default withTranslation()(RequestApprovalCard);
